// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t0ZnZ","header":"styles_header__6VwVM","no-dialog-chosen":"styles_no-dialog-chosen__eYGmU","folder-name":"styles_folder-name__WJuCA"};